// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconPteusde } from "../../../icons/mono/build/icon-pteusde.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const PteusdeIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconPteusde.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  PteusdeIcon.displayName = 'PteusdeIcon';
}

export default PteusdeIcon;